import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthState } from '../../auth/store/auth.model';
import { AuthService } from '../../auth/auth.service';
import { selectError, selectIsLoading } from '../../auth/store/auth.selector';
import { DeviceModalComponent } from '../../components/device-modal/device-modal.component';
import { ToasterService } from '../../providers/toaster/toaster.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, DeviceModalComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  loginForm: FormGroup;
  isPasswordVisible: boolean = false;

  isLoading$;
  error$;

  @ViewChild(DeviceModalComponent) deviceModal!: DeviceModalComponent;

  constructor(private fb: FormBuilder, private store: Store<AuthState>,
    private authService: AuthService, private toasterService: ToasterService, private http: HttpClient, private router: Router) {

    this.isLoading$ = this.store.select(selectIsLoading);
    this.error$ = this.store.select(selectError);

    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const { email, password } = this.loginForm.value;
    this.authService.login(email, password).subscribe({
      next: (response) => {
        if (response.status === 'success') {
          this.toasterService.setToaster('success', 'login success', response.message);
          // Check if device_id exists in localStorage
          const deviceId = localStorage.getItem('device_id');
          if (deviceId) {
            // Call /device/check API to verify
            this.checkDevice(deviceId);
          } else {
            // No device_id, open modal
            this.deviceModal.openModal();
          }
        } else {
          this.toasterService.setToaster('error', 'login failed', response.message);
        }
      },
      error: (error) => {
        this.toasterService.setToaster('error', 'login failed', 'something went wrong');
      }
    });

    console.log(this.loginForm.value);
  }

  checkDevice(deviceId: string) {
    const authData = localStorage.getItem('auth_data');
    if (authData) {
      const { token, user } = JSON.parse(authData);
      this.http.get(`${environment.apiUrl}device/check?device_id=${deviceId}&user_id=${user?.id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).subscribe({
        next: (response: any) => {
          if (response.status === true) {
            // Device matches, navigate to dashboard
            this.router.navigate(['/dashboard']);
          } else {
            // Device does not match, open modal
            this.deviceModal.openModal();
          }
        },
        error: (error) => {
          // Error in check, open modal
          this.deviceModal.openModal();
        }
      });
    } else {
      // No auth data, open modal
      this.deviceModal.openModal();
    }
  }
}
